import { DataSrc, ModelParameter } from "../mlmodel/mlModel-parameters.model";

export class InputParameter {
  data: ModelParameter;
  mappedDataSource: DataSrc;
  mappedDataSourceId: string;
  mappedParameterId: number;
  mappedParameterName: string;
  mappedFrequency: number;
  mappedParameterUoM: string;

  constructor() {
    this.data = new ModelParameter();
    this.mappedDataSource = DataSrc.user;
    this.mappedDataSourceId = '1';
    this.mappedParameterId = 0;
    this.mappedParameterName = '';
    this.mappedFrequency = 0;
    this.mappedParameterUoM = '';
  }

}
